import EnvConfig from "./EnvConfig";
import {
  gettRequest,
  postRequest,
  postFileRequest,
  patchRequest,
  deleteRequest,
  putRequest,
} from "config/ServicesConfig";
import { pdfgetRequest, rtPostRequest } from "./ServicesConfig";
import axios from "axios";

const METHOD = {
  GET: "GET",
  POST: "POST",
  PUT: "PUT",
  DELETE: "DELETE",
  PATCH: "PATCH",
};
const envBaseUrl = EnvConfig().baseConfigUrl;

const API = axios.create({ baseURL: `${envBaseUrl}` });

const hasValidPathId = (id) =>
  id !== null && id !== undefined && id !== "" && id !== "null" && id !== "undefined";

API.interceptors.request.use(async (req) => {
  const at = await localStorage.getItem("access_token");
  if (at) req.headers["at"] = at;
  return req;
});

const appVersionUrl = "https://originhighway-staging-kxyaws5ixa-uc.a.run.app/";

export const servicesList = {
  products: "products",
  catalogService: "catalog",
  userAuth: "auth",
  cart: "cart",
  retailService: "retail-service",
  retail: "retail",
  orderService: "oms",
  userService: "user-service",
  gatewayService: "gateway",
  couponService: "coupon",
  loyaltyService: "loyalty",
  inventoryService: "ims",
  sessionService: "pos-service",
  businessService: "business",
  logisticsService: "logistics",
  serviceability: "serviceability",
  paymentService: "payments",
  customerService: "b2c",
  thirdPartyLayer: "tpl",
  palletBusiness: "business",
  vendorVms: "vms",
};

export const FetchCategory = () => API.get(servicesList.catalogService + "/category/main");

export const filterCategory = (payload) => {
  const url = envBaseUrl + servicesList.catalogService + "/category/main/filter";
  return postRequest(url, payload);
};

export const aggsFilterCategory = (payload) => {
  const url = envBaseUrl + servicesList.catalogService + "/v1/product/common/aggs/category/level1";
  return postRequest(url, payload);
};

/* ── Category list with IDs ──────────────────────────────── */
export const fetchCategoryViewFilter = (payload) => {
  const url = envBaseUrl + servicesList.catalogService + "/category/view/filter";
  return postRequest(url, payload);
};

/* ── Products grouped by level-1 category ───────────────── */
export const fetchCategoryProductsLevel1 = (payload) => {
  const url = envBaseUrl + servicesList.catalogService + "/v1/product/common/categories/level1";
  return postRequest(url, payload);
};

export const SkipUserFun = (payload) => {
  const url = envBaseUrl + servicesList.cart + "/pos/v1/create";
  return postRequest(url, payload);
};

export const addCustomer = (payload) => {
  const url = envBaseUrl + servicesList.userService + "/customer";
  return postRequest(url, payload);
};

export const AddItemThroughScanner = (payload) => {
  const url = envBaseUrl + servicesList.cart + `/v1/cart/product/add/manual/pos`;
  return postRequest(url, payload);
};

export const addOpenProductToCart = (payload) => {
  const url = envBaseUrl + servicesList.cart + `/v1/restaurant/cart/add/open/product`;
  return postRequest(url, payload);
};

export const decreaseItemThroughScanner = (payload) => {
  const url = envBaseUrl + servicesList.cart + `/v2/pos/decrease`;
  return postRequest(url, payload);
};

export const increaseItemThroughScanner = (payload) => {
  const url =
    envBaseUrl +
    servicesList.cart +
    `/product/increase/${payload.cartId}?gtin=${payload.gtin}&inventoryCheck=NO`;
  return postRequest(url, payload);
};

export const deleteValidationItem = ({ cartId, cartProductId }) => {
  const url =
    envBaseUrl + servicesList.cart + `/v2/sales-order/delete/product/${cartId}/${cartProductId}`;
  return postRequest(url);
};

export const deleteItemThroughScanner = (payload) => {
  const url = envBaseUrl + servicesList.cart + `/v2/pos/remove`;
  return postRequest(url, payload);
};

export const deleteItemRestaurant = (payload) => {
  const url = envBaseUrl + servicesList.cart + `/v1/restaurant/cart/product/remove`;
  return postRequest(url, payload);
};

export const deleteWholeCart = (payload) => {
  const url = envBaseUrl + servicesList.cart + `/v1/restaurant/cart/product/remove/multiple`;
  return postRequest(url, payload);
};

export const userOtpVerification = (payload) => {
  const url = envBaseUrl + servicesList.userAuth + "/otp/verify";
  return postRequest(url, payload);
};

export const userVerification = (payload) => {
  const url = envBaseUrl + servicesList.userAuth + "/pos/user/login";
  return postRequest(url, payload);
};

export const userIdVerification = (payload) => {
  const url = envBaseUrl + servicesList.userAuth + "/retail/user";
  return postRequest(url, payload);
};

export const getUserDetails = () => {
  const url = envBaseUrl + servicesList.userService + "/user";
  return gettRequest(url, METHOD.GET);
};

export const getRetailUserDetails = (retailId) => {
  const url = envBaseUrl + servicesList.retail + `/retail/v1/get/details?id=${retailId}`;
  return gettRequest(url, METHOD.GET);
};

export const getCustomerOrderSummary = (retailId, payload) => {
  const url =
    envBaseUrl + servicesList.orderService + `/orders/customer-orders-summary/${retailId}`;
  return postRequest(url, payload);
};

export const getCustomerOrdersV1 = (payload) => {
  const url = envBaseUrl + servicesList.orderService + `/customer/customer-orders`;
  return postRequest(url, payload);
};

export const getCustomerList = (orgId) => {
  const url = envBaseUrl + servicesList.retailService + `/retail/v1/customer/get?retailId=${orgId}`;
  return gettRequest(url, METHOD.GET);
};

export const getAllOrderlist = (payload) => {
  const url = envBaseUrl + servicesList.orderService + `/orders/v3/order-filter`;
  return postRequest(url, payload);
};

export const getSlotStatusCount = (payload) => {
  const url = envBaseUrl + servicesList.orderService + `/orders/slots/counts`;
  return postRequest(url, payload);
};

export const getAllOrderlistV2 = (payload) => {
  const url = envBaseUrl + servicesList.orderService + `/orders/v2/order-filter`;
  return postRequest(url, payload);
};

export const getOrderDetails = (orderId, locId) => {
  const url =
    envBaseUrl + servicesList.orderService + `/orders/order/${orderId}?locationId=${locId}`;
  return gettRequest(url, METHOD.GET);
};

export const getOrdersStatus = (orderId) => {
  const url = envBaseUrl + servicesList.orderService + `/orders/trackFulfilmentStatus/${orderId}`;
  return gettRequest(url, METHOD.GET);
};

export const getOrderComments = (orderId) => {
  const url = envBaseUrl + servicesList.orderService + `/comments/comments/${orderId}`;
  return gettRequest(url, METHOD.GET);
};

export const createOrderComment = (payload) => {
  const url = envBaseUrl + servicesList.orderService + `/comments/create`;
  return postRequest(url, payload);
};

export const updateOrderTimeline = (payload) => {
  const url = envBaseUrl + servicesList.orderService + `/orders/updateFulfilmentStatus/`;
  return postRequest(url, payload);
};

export const cancelB2COrder = (payload) => {
  const url = envBaseUrl + servicesList.orderService + `/orders/v1/cancel/order/B2C`;
  return postRequest(url, payload);
};

export const getOrderPaymentDetails = ({ id }) =>
  API.get(servicesList.orderService + `/orders/order/${id}`);

export const orderStatusRetry = (orderId) => {
  const url = envBaseUrl + servicesList.orderService + `/orders/status/${orderId}`;
  return gettRequest(url, METHOD.GET);
};

export const orderRetryMethod = (payload) => {
  const url = envBaseUrl + servicesList.orderService + `/orders/retry`;
  return postRequest(url, payload);
};

export const FilterProduct = (payload) => {
  const url = envBaseUrl + servicesList.catalogService + "/product/v2/filter/product";
  return postRequest(url, payload);
};

export const getAllProducts = (payload) => {
  const url = envBaseUrl + "catalog/filter/product";
  return postRequest(url, payload);
};

export const particularCategoryData = (payload) => {
  const url = envBaseUrl + servicesList.catalogService + `/filter/product`;
  return postRequest(url, payload);
};

export const SuggestionSearch = (payload) => {
  const url = envBaseUrl + servicesList.catalogService + "/filter/product";
  return postRequest(url, payload);
};

export const getGlobalProductsList = (payload, config) => {
  const url = envBaseUrl + servicesList.catalogService + "/v1/pos/filter/product";
  return postRequest(url, payload, config);
};

export const getGlobalProductsListV2 = (payload) => {
  const url = envBaseUrl + servicesList.catalogService + "/product/v2/filter/product";
  return postRequest(url, payload);
};

/* ── Generate a unique barcode from the catalog service ── */
export const GenerateBundleBarcode = () => {
  const url = envBaseUrl + servicesList.catalogService + "/barcode/generate";
  return postRequest(url, {});
};

/* ── Bundle creation (CMS + IMS) ── */
export const CreateBundleCMS = (payload) => {
  const url = envBaseUrl + servicesList.catalogService + "/product/v2/create";
  return postRequest(url, payload);
};

export const CreateBundleIMS = (payload) => {
  const url = envBaseUrl + servicesList.inventoryService + "/api/bundle/v3/create";
  return postRequest(url, payload);
};

export const getBundleIMS = (productId, locId) => {
  const url =
    envBaseUrl + servicesList.inventoryService + "/api/bundle/v1/" + `${locId}/${productId}`;
  return gettRequest(url, METHOD.GET);
};

/* Bundle listing — catalog filter with showBundles */
export const FetchBundleList = (payload) => {
  const url = envBaseUrl + servicesList.catalogService + "/product/v2/filter/product";
  return postRequest(url, payload);
};

export const holdcartStatus = (payload) => {
  const url = envBaseUrl + servicesList.cart + "/update/status";
  return patchRequest(url, payload);
};

export const appVersioningApi = () => {
  const url = appVersionUrl + servicesList.gatewayService + "/app-version";
  return gettRequest(url, METHOD.GET);
};

export const searchItemList = (payload) => {
  const url = envBaseUrl + servicesList.catalogService + `/product/search/${payload}`;
  return postRequest(url);
};

export const holdCartListSession = ({ sourceLocationId, destinationId, loggedInUser = "" }) => {
  const url =
    envBaseUrl +
    servicesList.cart +
    `/cart/status?loggedInUser=${loggedInUser}&sourceLocationId=${sourceLocationId}&destinationId=${destinationId}&status=HOLD`;
  return gettRequest(url, METHOD.GET);
};

export const holdCartList = (payload) => {
  const url = envBaseUrl + servicesList.cart + "/v1/restaurant/cart/filter";
  return postRequest(url, payload);
};

export const AddedCustomerData = (payload) => {
  const url = envBaseUrl + servicesList.retailService + `/retail/v1/customer/add`;
  return postRequest(url, payload);
};

export const dataRetriveWhenPageRefresh = (payload) => {
  const url = envBaseUrl + servicesList.cart + `/common/cart/get/${payload}`;
  return gettRequest(url, METHOD.GET);
};
export const CreateOrder = (payload) => {
  const url = envBaseUrl + servicesList.cart + `/v2/pos/create/order`;
  return postRequest(url, payload);
};
export const CreateRestaurantOrder = (payload) => {
  const url = envBaseUrl + servicesList.cart + `/v1/restaurant/cart/create/order`;
  return postRequest(url, payload);
};

export const getRetailDetails = (retailId) => {
  const url = envBaseUrl + servicesList.retailService + `/retail/v1/get/details?id=${retailId}`;
  return gettRequest(url, METHOD.GET);
};

export const getRetailDetailsByBranch = (locId) => {
  const url = envBaseUrl + servicesList.retailService + `/branch/v1/bill/details?branchId=${locId}`;
  return gettRequest(url, METHOD.GET);
};

export const getLoyaltyDetails = (retailId, uidx) => {
  const url =
    envBaseUrl +
    servicesList.loyaltyService +
    `/api/customers/accounts/v1/end-customers/fetch?customerUidx=${uidx}&sourceOrgId=${retailId}&platformType=B2C`;
  return gettRequest(url, METHOD.GET);
};

export const getLoyaltyHistory = (payload) => {
  const url =
    envBaseUrl + servicesList.loyaltyService + `/api/transactions/loyaltyPoints/v1/history`;
  return postRequest(url, payload);
};

export const getCustomerDetails = (payload) => {
  const url = envBaseUrl + servicesList.userService + "/user/mobile";
  return postRequest(url, payload);
};

export const getAllCoupons = (payload) => {
  const url =
    envBaseUrl + servicesList.couponService + `/api/v1/display/coupon?pageNo=1&limit=1000`;
  return postRequest(url, payload);
};

export const completePayment = (payload) => {
  const url = envBaseUrl + servicesList.orderService + `/payments/v1/record`;
  return postRequest(url, payload);
};

export const adjustOrderAPI = (order_id, payload) => {
  const url = envBaseUrl + servicesList.orderService + `/orders/updateOrderStatus/${order_id}`;
  return postRequest(url, payload);
};

export const updatecartStatus = (payload) => {
  const url = envBaseUrl + servicesList.cart + `/update/status`;
  return patchRequest(url, payload);
};

export const deleteHoldcart = (cartId) => {
  const url = envBaseUrl + servicesList.cart + `/delete/single/${cartId}`;
  return postRequest(url, cartId);
};

export const applyCouponcode = (payload) => {
  const url = envBaseUrl + servicesList.cart + `/coupon/apply?inventoryCheck=NO`;
  return postRequest(url, payload);
};

export const applyRestaurantCouponcode = (payload) => {
  const url = envBaseUrl + servicesList.cart + `/common/cart/coupon/apply`;
  return postRequest(url, payload);
};

export const reprintReceipt = (orderId) => {
  const url = envBaseUrl + servicesList.orderService + `/orders/pos/invoicepdf/${orderId}`;
  return pdfgetRequest(url, METHOD.GET);
};

export const removecoupon = (cartId) => {
  const url = envBaseUrl + servicesList.cart + `/coupon/remove/${cartId}?inventoryCheck=NO`;
  return postRequest(url, cartId);
};

export const getAllUserDetails = (payload) => {
  const url = envBaseUrl + servicesList.userService + "/user/uidx/details";
  return postRequest(url, payload);
};

export const newCartCreationAfterAdjusting = (cartId, order_id) => {
  const url =
    envBaseUrl + servicesList.cart + `/adjust/${cartId}?order-id=${order_id}&inventoryCheck=NO`;
  return postRequest(url);
};

export const newCartcreationPaymentCancel = (cartId, order_id) => {
  const url =
    envBaseUrl +
    servicesList.cart +
    `/adjust/${cartId}?order-id=${order_id}&inventoryCheck=NO&paymentStatus=true`;
  return postRequest(url);
};
export const getOrderAmt = (orderId) => {
  const url = envBaseUrl + servicesList.orderService + `/orders/order/${orderId}`;
  return gettRequest(url, METHOD.GET);
};

export const getUserFromUidx = (uidx) => {
  const url = envBaseUrl + servicesList.userService + `/user/${uidx}`;
  return gettRequest(url, METHOD.GET);
};

export const pinMobVerify = (payload) => {
  const url = envBaseUrl + servicesList.userAuth + "/user/login/pin";
  return postRequest(url, payload);
};

export const pinMobVerifyV2 = (payload) => {
  const url = envBaseUrl + servicesList.userAuth + "/user/v2/login/pin";
  return postRequest(url, payload);
};

export const resetPin = (payload) => {
  const url = envBaseUrl + servicesList.userAuth + "/user/reset/pin";
  return postRequest(url, payload);
};

export const updatePin = (payload) => {
  const url = envBaseUrl + servicesList.userAuth + "/user/update/pin";
  return postRequest(url, payload);
};
export const latestBill = (uidx, locationId) => {
  const url = envBaseUrl + servicesList.orderService + `/orders/latestBill/${uidx}/${locationId}`;
  return gettRequest(url, METHOD.GET);
};

export const logoutSession = (payload) => {
  const url = envBaseUrl + servicesList.userAuth + `/user/logout`;
  return postRequest(url, payload);
};

export const sessionAmounpaid = (payload) => {
  const url = envBaseUrl + servicesList.orderService + `/pos/dashboard/v1/startSession`;
  return postRequest(url, payload);
};

export const fetchLoyality = ({ params }) =>
  API.post(servicesList.loyaltyService + `/api/loyaltyPoints/v3/details/redeemable`, params);

export const redeemLoyalty = (payload, cartId) => {
  const url = envBaseUrl + servicesList.cart + `/loyalty/redeem/${cartId}?inventoryCheck=NO`;
  return postRequest(url, payload);
};

export const reedemCheck = (orgId) => {
  const url =
    envBaseUrl + servicesList.loyaltyService + `/api/configurations/v1/fetch?sourceOrgId=${orgId}`;
  return gettRequest(url, METHOD.GET);
};

export const getOrgDetails = (payload) => {
  const url = envBaseUrl + servicesList.retailService + "/retail/v1/get/all";
  return postRequest(url, payload);
};

export const getBranchDetails = (branch_id) => {
  const url =
    envBaseUrl + servicesList.retailService + `/branch/v1/get/details?branchId=${branch_id}`;
  return gettRequest(url, METHOD.GET);
};

export const getBranchAddress = (locId) => {
  const url = envBaseUrl + servicesList.retailService + `/branch/v1/address/get?branchId=${locId}`;
  return gettRequest(url, METHOD.GET);
};

/**
 * Verify a GSTIN via the vendor KYC service and return business name + address.
 * gstNo: 15-character GST Identification Number
 * Endpoint: GET {base}/vms/kyc/gst/{gstNo}
 */
export const VerifyGST = (gstNo) => {
  const url = envBaseUrl + servicesList.vendorVms + `/kyc/gst/${encodeURIComponent(gstNo)}`;
  return gettRequest(url, METHOD.GET);
};

/**
 * List retail partners for the current org (paginated, POST).
 * payload: { pageNumber, pageSize, partnerId, startDate, endDate, partnerType, searchParameter? }
 */
export const getRetailPartnerList = (payload) => {
  const url = envBaseUrl + servicesList.retail + `/retail/v2/get/partner/retail`;
  return postRequest(url, payload);
};

/**
 * Fetch full details for a single retail partner.
 * retailId: e.g. "RET_1641"
 */
export const getRetailPartnerDetails = (retailId) => {
  const url = envBaseUrl + servicesList.retail + `/retail/v1/get/details/?id=${retailId}`;
  return gettRequest(url, METHOD.GET);
};

/**
 * Create a SALES_ORDER (B2B / GST) cart.
 * payload: see /proxy/cart/so/v1/cart/create spec.
 */
export const createSalesOrderCart = (payload) => {
  const url = envBaseUrl + servicesList.cart + `/so/v1/cart/create`;
  return postRequest(url, payload);
};

export const editCart = (payload) => {
  const url = envBaseUrl + servicesList.cart + `/v1/cart/add/product/qty/pos`;
  return postRequest(url, payload);
};

/**
 * Add an item to the cart, but if the same gtin is already present in
 * cartItemsSnapshot, increment its quantity via editCart instead of creating
 * a duplicate row.  Response is always normalised to the AddItemThroughScanner
 * shape (res.data.data.data.cartProducts / .billing) so all callers work as-is.
 */
export const addToCartDedup = async (payload, cartItemsSnapshot = []) => {
  const gtin = payload?.gtin;
  const requestedBatchNo =
    payload?.batchNo !== undefined && payload?.batchNo !== null
      ? String(payload.batchNo).trim()
      : "";
  const getBatchNo = (item) => {
    const batchNo = item?.batchNo ?? item?.batchNum ?? item?.batch;
    return batchNo !== undefined && batchNo !== null ? String(batchNo).trim() : "";
  };

  const existing = Array.isArray(cartItemsSnapshot)
    ? cartItemsSnapshot.find((ci) => {
        if (ci?.gtin !== gtin) return false;

        // Batch selections represent separate cart rows. Keep the existing
        // GTIN-only deduplication for regular products, but require the same
        // batch number when the add request identifies a batch.
        if (requestedBatchNo) {
          return getBatchNo(ci) === requestedBatchNo;
        }

        return true;
      })
    : null;

  if (existing?.cartProductId) {
    const editRes = await editCart({
      cartId: payload.cartId,
      cartProductId: existing.cartProductId,
      qty: (existing.quantity || 0) + 1,
      quantityBySpecs: null,
      updatedBy: "",
      sellingPrice: existing.sellingPrice || payload.sellingPrice || payload.mrp || "",
    });
    /* Normalise editCart response → AddItemThroughScanner shape so all
     * existing response handlers (res.data.data.data.cartProducts / .billing)
     * work unchanged.
     *
     * editCart returns a 3-level response:
     *   res.data.data         = { es, message, data: { cartProducts, billing, ... } }
     *   res.data.data.data    = { cartProducts, billing, ... }   ← the cart object
     *
     * esLevel = the { es, data } wrapper; inner = the actual cart object.
     * The ?? fallback handles any variant where .data is omitted.            */
    const esLevel = editRes?.data?.data;
    const inner = esLevel?.data ?? esLevel;
    return {
      ...editRes,
      data: {
        ...editRes.data,
        data: {
          es: esLevel?.es ?? 0,
          message: esLevel?.message,
          data: inner,
        },
      },
    };
  }

  return AddItemThroughScanner(payload);
};

export const flushCart = (cartId) => {
  const url = envBaseUrl + servicesList.cart + `/product/remove/all/${cartId}?inventoryCheck=NO`;
  return postRequest(url);
};

export const postPrnFile = (payload) => {
  const url = `https://localhost:8442/v1/printer/print`;
  return postFileRequest(url, payload);
};

export const removeLoyalty = (cartId) => {
  if (!hasValidPathId(cartId)) {
    return Promise.reject(new Error("CartId is required to remove loyalty"));
  }

  const url = envBaseUrl + servicesList.cart + `/loyalty/remove/${cartId}?inventoryCheck=NO`;
  return postRequest(url);
};

export const createSession = (payload) => {
  const url = envBaseUrl + servicesList.sessionService + `/session/v2/create`;
  return postRequest(url, payload);
};

export const getSessionData = (payload) => {
  const url = envBaseUrl + servicesList.sessionService + `/session/v2/get/location`;
  return postRequest(url, payload);
};

export const getLoyaltyDetailsData = (payload) => {
  const url = envBaseUrl + servicesList.loyaltyService + `/api/loyaltyPoints/v1/rewards/fetch`;
  return postRequest(url, payload);
};

export const getPosUserRole = (payload) => {
  const url = envBaseUrl + servicesList.userService + "/pos/role";
  return postRequest(url, payload);
};

export const getLicenseLocation = (orgId, locId) => {
  const url =
    envBaseUrl +
    servicesList.sessionService +
    `/license/v1/get?organizationId=${orgId}&locationId=${locId}`;
  return gettRequest(url, METHOD.GET);
};

export const getManagers = (payload) => {
  const url = envBaseUrl + servicesList.userService + `/pos/location/managers`;
  return postRequest(url, payload);
};

export const getCashDrawerDetails = (sessionId) => {
  const url =
    envBaseUrl +
    servicesList.sessionService +
    `/drawer/v2/details/session?userSessionId=${sessionId}`;
  return gettRequest(url, METHOD.GET);
};

export const validateCashDrawer = (payload) => {
  const url = envBaseUrl + servicesList.userService + `/user/manager/validate/pin`;
  return postRequest(url, payload);
};

export const validateManagerPin = (payload) => {
  const url = envBaseUrl + servicesList.userService + `/user/validate/pin`;
  return postRequest(url, payload);
};

export const getSessionCloseDetails = (locId, licenseId, sessionId) => {
  const url =
    envBaseUrl +
    servicesList.orderService +
    `/pos/dashboard/v1/session/${locId}/${licenseId}/${sessionId}`;
  return gettRequest(url, METHOD.GET);
};

export const dashBoardData = ({ params }) =>
  API.get(
    servicesList.orderService +
      `/pos/dashboard/v1/session/${params?.loc_Id}/${params?.licenseId}/${params?.sessionId}`
  );

export const dashBoardDataRestaurant = ({ params }) =>
  API.post(servicesList.orderService + `/restaurant/dashboard/data`, params);

export const getStoreActivity = (locId, orgId, sessionId, mPos) => {
  const url =
    envBaseUrl +
    servicesList.sessionService +
    `/session/v1/get/rms/dashboard/activity?locationId=${locId}&organizationId=${orgId}&daySessionId=${sessionId}&mPos=${mPos}`;
  return gettRequest(url, METHOD.GET);
};

export const closeSession = (payload) => {
  const url = envBaseUrl + servicesList.sessionService + `/session/v2/close`;
  return postRequest(url, payload);
};

export const getAllSessionLicenseActive = (licenseId) => {
  const url =
    envBaseUrl + servicesList.sessionService + `/session/v2/get/license?licenseId=${licenseId}`;
  return gettRequest(url, METHOD.GET);
};

export const getActiveSession = (uidx, locId, sessionId) => {
  const url =
    envBaseUrl +
    servicesList.sessionService +
    `/session/v2/get/active?uidx=${uidx}&locationId=${locId}&daySessionId=${sessionId}`;
  return gettRequest(url, METHOD.GET);
};

export const getAllUserOrgs = (payload) => {
  const url = envBaseUrl + servicesList.userService + "/user/orgIds";
  return postRequest(url, payload);
};

export const GetRetailnames_location = async (payload) => {
  const url = envBaseUrl + servicesList.retailService + `/retail/v1/retail/list`;
  return await postRequest(url, payload);
};

export const customerPerSession = (sessionId) => {
  const url =
    envBaseUrl + servicesList.retailService + `/retail/v1/customer/session?sessionId=${sessionId}`;
  return gettRequest(url, METHOD.GET);
};

export const rtValidation = () => {
  const url = envBaseUrl + servicesList.userAuth + "/validate/refresh/token";
  return rtPostRequest(url);
};

export const activeSessionDay = (locId) => {
  const url = envBaseUrl + servicesList.sessionService + `/day/v2/get/active?locationId=${locId}`;
  return gettRequest(url, METHOD.GET);
};

export const startDay = (payload) => {
  const url = envBaseUrl + servicesList.sessionService + `/day/v1/start`;
  return postRequest(url, payload);
};

export const getMachineCode = (payload) => {
  const url = envBaseUrl + servicesList.businessService + `/api/license/machine/details`;
  return postRequest(url, payload);
};

export const getGraphData = (locId, licenseId, sessionId) => {
  const url =
    envBaseUrl +
    servicesList.orderService +
    `/pos/dashboard/v1/orders/hourly/trend/${locId}/${licenseId}/${sessionId}`;
  return gettRequest(url, METHOD.GET);
};

export const atRefresh = () => {
  const url = envBaseUrl + servicesList.userAuth + "/refresh/token";
  return rtPostRequest(url);
};

export const denominationAPI = (payload) => {
  const url = envBaseUrl + servicesList.sessionService + `/session/v2/close`;
  return postRequest(url, payload);
};

export const orderCancelRequest = (payload) => {
  const url = envBaseUrl + servicesList.orderService + `/orders/order/cancel/transaction`;
  return postRequest(url, payload);
};

export const customerDetailsInfo = (uidx) => {
  const url = envBaseUrl + servicesList.userService + `/user/${uidx}`;
  return gettRequest(url, METHOD.GET);
};

export const customerLoyaltyDetails = (payload) => {
  const url =
    envBaseUrl + servicesList.loyaltyService + `/api/transactions/loyaltyPoints/v1/details`;
  return postRequest(url, payload);
};

export const getCustomerPaginationList = (payload) => {
  const url = envBaseUrl + servicesList.retailService + `/retail/v1/customer/location`;
  return postRequest(url, payload);
};

export const newCartItemsAddingProducts = (payload) => {
  const url = envBaseUrl + servicesList.cart + `/v1/cart/product/add/pos`;
  return postRequest(url, payload);
};

export const addRestaurantProducts = (payload) => {
  const url = envBaseUrl + servicesList.cart + `/v1/restaurant/cart/add/product`;
  return postRequest(url, payload);
};

export const newPosNavbarCartItemsAddingProducts = ({ params, data, ...props }) =>
  API.post(servicesList.cart + `/v4/product/add/pos`, data || props || params);

export const editUserDetails = (payload, uidx) => {
  const url = envBaseUrl + servicesList.userService + `/user/${uidx}`;
  return putRequest(url, payload);
};

export const cancelOrder = (payload) => {
  const url = envBaseUrl + servicesList.orderService + `/orders/v2/cancel/order/pos`;
  return postRequest(url, payload);
};

export const getLocDetailByLongAndLat = (latitude, longitude) => {
  const url = `https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=${latitude}&lon=${longitude}`;
  return gettRequest(url, METHOD.GET);
};

export const payOrderSplit = (payload) => {
  const url = envBaseUrl + servicesList.orderService + `/orders/v2/payOrder`;
  return postRequest(url, payload);
};

export const getPaymentStatus = (transId) => {
  const url = envBaseUrl + servicesList.orderService + `/orders/payment/status/${transId}`;
  return gettRequest(url, METHOD.GET);
};

export const getCreditPaymentStatus = (transId, settlement, setID) => {
  const url =
    envBaseUrl +
    servicesList.orderService +
    `/orders/payment/status/${transId}?settlement=${settlement}&settlementId=${setID}`;
  return gettRequest(url, METHOD.GET);
};

export const getAllOffers = (payload) => {
  const url = envBaseUrl + servicesList.inventoryService + "/api/inventory/v1/offers/filter";
  return postRequest(url, payload);
};

export const getSingleProductOffer = (payload) => {
  const url =
    envBaseUrl + servicesList.inventoryService + "/api/inventory/v1/offers/by-batches/get";
  return postRequest(url, payload);
};

export const cartOfferValidation = (cartId) => {
  const url = envBaseUrl + servicesList.cart + `/v2/pos/validate/offer/${cartId}`;
  return postRequest(url);
};

export const validateCartProduct = (payload) => {
  const url = envBaseUrl + servicesList.cart + `/v2/b2c/validate/cart`;
  return postRequest(url, payload);
};

export const validateItemManual = (payload) => {
  const url = envBaseUrl + servicesList.cart + `/v2/b2c/validate/manual`;
  return postRequest(url, payload);
};

export const validateCartProductWithBatch = (payload) => {
  const url = envBaseUrl + servicesList.cart + `/v2/b2c/validate/update/cart`;
  return postRequest(url, payload);
};

export const createValidatedOrder = (payload) => {
  const url = envBaseUrl + servicesList.cart + `/v2/b2c/validated/place/order`;
  return postRequest(url, payload);
};

export const assignPicker = (payload) => {
  const url = envBaseUrl + servicesList.orderService + `/orders/assign/picklist`;
  return postRequest(url, payload);
};

export const createShipment = (payload) => {
  const url = envBaseUrl + servicesList.logisticsService + `/api/shipments/v1/create`;
  return postRequest(url, payload);
};

export const cancelShipment = (payload) => {
  const url = envBaseUrl + servicesList.logisticsService + `/api/shipments/v1/cancel`;
  return postRequest(url, payload);
};

export const createTrip = (payload) => {
  const url = envBaseUrl + servicesList.logisticsService + `/api/trips/v1/create`;
  return postRequest(url, payload);
};

export const updateTrip = (payload) => {
  const url = envBaseUrl + servicesList.logisticsService + `/api/trips/v1/update`;
  return postRequest(url, payload);
};

export const getShipmentFromOrderId = (orderId) => {
  const url = envBaseUrl + servicesList.logisticsService + `/api/shipments/v1/${orderId}`;
  return gettRequest(url, METHOD.GET);
};

export const getTripList = (orgId, locId) => {
  const url =
    envBaseUrl +
    servicesList.logisticsService +
    `/api/agents/v1/tripDetails/overview?sourceOrgId=${orgId}&sourceLocId=${locId}`;
  return gettRequest(url, METHOD.GET);
};

export const filterCutoff = (payload) => {
  const url = envBaseUrl + servicesList.serviceability + `/api/cutoff/v2/filter`;
  return postRequest(url, payload);
};

export const updateInstantSlot = (payload) => {
  const url = envBaseUrl + servicesList.serviceability + `/instant/delivery/update`;
  return postRequest(url, payload);
};

export const getUsersByRole = (payload) => {
  const url = envBaseUrl + servicesList.userService + `/user/location/roles`;
  return postRequest(url, payload);
};

export const getUserDisplayMode = (uidx) => {
  const url = envBaseUrl + servicesList.userService + `/user/display/mode?uidx=${uidx}`;
  return gettRequest(url, METHOD.GET);
};

export const setDisplayMode = (payload) => {
  const url = envBaseUrl + servicesList.userService + `/user/display/mode`;
  return postRequest(url, payload);
};

export const updateDisplayMode = (payload) => {
  const url = envBaseUrl + servicesList.userService + "/user/display/mode";
  return patchRequest(url, payload);
};

export const getAllOrgPaymentMethods = (payload) => {
  const url = envBaseUrl + servicesList.paymentService + `/method/v1/${payload}`;
  return gettRequest(url, METHOD.GET);
};

export const validateLoyaltyOtp = (payload) => {
  const url =
    envBaseUrl + servicesList.loyaltyService + `/api/loyaltyPoints/v1/redeem/validate/otp`;
  return postRequest(url, payload);
};

export const userEventCreate = (payload) => {
  const url = envBaseUrl + servicesList.sessionService + `/event/v1/create`;
  return postRequest(url, payload);
};

export const orderMetricsCreate = (payload) => {
  const url = envBaseUrl + servicesList.sessionService + `/metrics/v1/order/create`;
  return postRequest(url, payload);
};

export const eventMetricsData = (sessionId) => {
  const url =
    envBaseUrl + servicesList.sessionService + `/metrics/metrics/v1/session?sessionId=${sessionId}`;
  return gettRequest(url, METHOD.GET);
};

export const getPrinterConfig = (orgId) => {
  const url = envBaseUrl + servicesList.retailService + `/configuration/v1/organization/${orgId}`;
  return gettRequest(url, METHOD.GET);
};

export const fetchOrganisations = () => {
  const url = envBaseUrl + servicesList.userService + "/user/orgs/uidx";
  return gettRequest(url, METHOD.GET);
};
export const cartOfferCalculate = (cartId) => {
  const url = envBaseUrl + servicesList.cart + `/v4/calculate/offers/${cartId}`;
  return postRequest(url);
};

export const closeAllCarts = (payload) => {
  const url = envBaseUrl + servicesList.cart + "/cart/session/hold/close";
  return postRequest(url, payload);
};

export const AddDeliveryChargeCart = (payload) => {
  const url = envBaseUrl + servicesList.cart + `/v2/b2c/apply/delivery/charges`;
  return postRequest(url, payload);
};

export const customerSearch = (payload) => {
  const url = envBaseUrl + servicesList.retailService + `/retail/customer/v1/search`;
  return postRequest(url, payload);
};

export const getLoyaltyInfo = (payload) => {
  const url =
    envBaseUrl +
    servicesList.loyaltyService +
    `/api/transactions/loyaltyPoints/v2/customer/details`;
  return postRequest(url, payload);
};

export const getCustomerInsightsCMS = (customerId) => {
  const url =
    envBaseUrl +
    servicesList.customerService +
    `/api/v1/customer-analytics/analytics/detail/${customerId}`;
  return gettRequest(url, METHOD.GET);
};

export const getProductDetails = (productId, locId) => {
  const url = envBaseUrl + servicesList.catalogService + "/product/gtin/" + `${productId}/${locId}`;
  return gettRequest(url, METHOD.GET);
};

export const getProductDetailsV2 = (productId, locId) => {
  const url = envBaseUrl + servicesList.catalogService + `product/v2/get/${productId}/${locId}`;
  return gettRequest(url, METHOD.GET);
};

export const getInventoryData = (locationId, gtin) => {
  const url =
    envBaseUrl +
    servicesList.inventoryService +
    `/api/WPC/v1/fetch-with-multiple-batches/get?locationId=${locationId}&gtin=${gtin}`;
  return gettRequest(url, METHOD.GET);
};

export const getOfferData = (offerId) => {
  const url =
    envBaseUrl + servicesList.inventoryService + `/api/inventory/v1/offers/get?offerId=${offerId}`;
  return gettRequest(url, METHOD.GET);
};

export const getPopularProducts = (date, locId) => {
  const url =
    envBaseUrl +
    servicesList.sessionService +
    `/metrics/v1/most/searched?date=${date}&locationId=${locId}`;
  return gettRequest(url, METHOD.GET);
};

export const redeemLoyaltyOtp = (payload) => {
  const url =
    envBaseUrl + servicesList.loyaltyService + `/api/loyaltyPoints/v1/redeem/generate/otp`;
  return postRequest(url, payload);
};

export const getPosConfigurations = (orgId) => {
  const url = envBaseUrl + servicesList.retailService + `/configuration/v1/organization/${orgId}`;
  return gettRequest(url, METHOD.GET);
};

export const getLoyaltyCorrespondingValue = (payload) => {
  const url =
    envBaseUrl + servicesList.loyaltyService + `/api/loyaltyPoints/v3/details/custom/redeemable`;
  return postRequest(url, payload);
};

export const createReturn = (payload) => {
  const url = envBaseUrl + servicesList.orderService + `/returns/create/return`;
  return postRequest(url, payload);
};

export const calculcateReturnAmount = (payload) => {
  const url = envBaseUrl + servicesList.orderService + `/returns/create/item/return`;
  return postRequest(url, payload);
};

export const fetchConsumedDays = (payload) => {
  const url = envBaseUrl + servicesList.orderService + `/orders/v6/order-filter`;
  return postRequest(url, payload);
};

export const returnsList = (payload) => {
  const url = envBaseUrl + servicesList.orderService + `/returns/v1/return-filter`;
  return postRequest(url, payload);
};

export const returnItemDetails = (returnId, orderId) => {
  const url =
    envBaseUrl +
    servicesList.orderService +
    `/returns/return?return-id=${returnId}&order-id=${orderId}`;
  return gettRequest(url, METHOD.GET);
};

export const healthCheck = (payload) => {
  const url = envBaseUrl + servicesList.sessionService + `/license/v1/health/check`;
  return postRequest(url, payload);
};

export const getStoreConfig = (locId) => {
  const url = envBaseUrl + servicesList.retailService + `/store-config/v1/get?locId=${locId}`;
  return gettRequest(url, METHOD.GET);
};

export const fetchSubMenu = (payload) => {
  const url = envBaseUrl + servicesList.catalogService + "/category/level1/filter";
  return postRequest(url, payload);
};

export const productCreation = (payload) => {
  const url = envBaseUrl + servicesList.catalogService + "/restaurant/product/create";
  return postRequest(url, payload);
};

export const productCreationIMS = (payload) => {
  const url = envBaseUrl + servicesList.inventoryService + "/api/v1/product/create";
  return postRequest(url, payload);
};

export const fetchAddOn = (payload) => {
  const url = envBaseUrl + servicesList.catalogService + "/product/v2/filter/product";
  return postRequest(url, payload);
};

export const createMenuCategory = (payload) => {
  const url = envBaseUrl + servicesList.catalogService + "/category/main/multiple/create";
  return postRequest(url, payload);
};

export const uploadImageBase64 = (payload) => {
  const url = envBaseUrl + servicesList.catalogService + "/product/v2/cloud/upload/images";
  return postRequest(url, payload);
};

export const uploadFileBase64 = (payload) => {
  const url = envBaseUrl + servicesList.catalogService + "/product/v2/cloud/upload/file";
  return postRequest(url, payload);
};

export const restaurantCreateCart = (payload) => {
  const url = envBaseUrl + servicesList.cart + `/v1/restaurant/cart/create`;
  return postRequest(url, payload);
};

export const getPrinterTemplates = () => {
  const url = envBaseUrl + servicesList.retailService + `/template/v1/get/all`;
  return postRequest(url);
};

export const updatePrinterTemplate = (payload) => {
  const url = envBaseUrl + servicesList.retailService + `/configuration/v1/update`;
  return postRequest(url, payload);
};

export const getPrinterIds = () => {
  const url = envBaseUrl + servicesList.retailService + `/peripheral/v1/get/all`;
  return gettRequest(url, METHOD.GET);
};

export const createVendorId = (payload) => {
  const url = envBaseUrl + servicesList.retailService + `/peripheral/v1/create`;
  return postRequest(url, payload);
};
export const updateProductQuantityOnCart = (payload) => {
  const url = envBaseUrl + servicesList.cart + `/v1/restaurant/cart/add/product/qty`;
  return postRequest(url, payload);
};

export const deletePorductFromCart = (payload) => {
  const url = envBaseUrl + servicesList.cart + `/v1/restaurant/cart/product/remove`;
  return postRequest(url, payload);
};

export const restaurantCartUpdate = (payload) => {
  const url = envBaseUrl + servicesList.cart + `/v1/restaurant/cart/update`;
  return patchRequest(url, payload);
};

export const getCreditOrders = (payload) => {
  const url = envBaseUrl + servicesList.orderService + `/accounts/filter/accounts`;
  return postRequest(url, payload);
};

export const creditAccountSearch = (payload) => {
  const url = envBaseUrl + servicesList.orderService + `/v7/accounts/search`;
  return postRequest(url, payload);
};

export const getCreditOrderDetails = (payload) => {
  const url = envBaseUrl + servicesList.orderService + `/accounts/account`;
  return postRequest(url, payload);
};

export const settlePayment = (payload) => {
  const url = envBaseUrl + servicesList.orderService + `/accounts/settle/account`;
  return postRequest(url, payload);
};

export const getSettlementDetails = (payload) => {
  const url = envBaseUrl + servicesList.orderService + `/accounts/filter/settlements`;
  return postRequest(url, payload);
};

export const createAddress = (payload) => {
  const url = envBaseUrl + servicesList.retailService + `/address/v1/create`;
  return postRequest(url, payload);
};

export const getAddress = (customerId) => {
  const url =
    envBaseUrl + servicesList.retailService + `/address/v1/customer?customerId=${customerId}`;
  return gettRequest(url, METHOD.GET);
};

export const deleteAddress = (payload) => {
  const url = envBaseUrl + servicesList.retailService + `/address/v1/delete`;
  return postRequest(url, payload);
};

export const updateAddress = (payload) => {
  const url = envBaseUrl + servicesList.retailService + `/address/v1/update`;
  return postRequest(url, payload);
};

export const getCustomerOrders = (payload) => {
  const url = envBaseUrl + servicesList.orderService + `/orders/v2/orders`;
  return postRequest(url, payload);
};

export const updateRestaurantMenu = (payload) => {
  const url = envBaseUrl + servicesList.catalogService + `/restaurant/product/update`;
  return postRequest(url, payload);
};

export const multipleProductCreation = (payload) => {
  const url = envBaseUrl + servicesList.catalogService + "/product/v2/multiple/product/creation";
  return postRequest(url, payload);
};

export const tableLayoutAvailability = (locId) => {
  const url = envBaseUrl + servicesList.retailService + `/layout/v1/details/all/fetch/${locId}`;
  return gettRequest(url, METHOD.GET);
};

export const getTableLayoutHierarchy = (orgId, locId, layoutId, format) => {
  const url =
    envBaseUrl +
    servicesList.retailService +
    `/layout/sub-entities/get/hierarchy?organisationId=${orgId}&ownerId=${locId}&layoutId=${layoutId}&includeTables=true&format=${format}`;
  return gettRequest(url, METHOD.GET);
};

export const createTableReservation = (payload) => {
  const url = envBaseUrl + servicesList.retailService + "/api/reservations/book";
  return postRequest(url, payload);
};

export const fetchReservationDetails = (orgId, locId, status) => {
  const url =
    envBaseUrl +
    servicesList.retailService +
    `/api/reservations/filter/status/${orgId}/${locId}/${status}`;
  return gettRequest(url, METHOD.GET);
};

export const manualTableReservation = (payload) => {
  const url = envBaseUrl + servicesList.retailService + "/api/reservations/manual/table/booking";
  return postRequest(url, payload);
};

export const manualTableCancellation = (slotId) => {
  const url = envBaseUrl + servicesList.retailService + `/api/reservations/force-expire/${slotId}`;
  return putRequest(url, slotId);
};

export const fetchTableBookingStatus = (orgId, locId, status) => {
  const url =
    envBaseUrl +
    servicesList.retailService +
    `/api/reservations/filter/status/${orgId}/${locId}/${status}`;
  return gettRequest(url, METHOD.GET);
};

export const checkedInAndCheckedOut = (slotId, status) => {
  const url =
    envBaseUrl +
    servicesList.retailService +
    `/api/reservations/checkin/checkout/${slotId}/${status}`;
  return postRequest(url, METHOD.POST);
};

export const sendToKDS = (payload) => {
  const url = envBaseUrl + servicesList.cart + "/v1/restaurant/cart/send/to/kitchen";
  return postRequest(url, payload);
};

export const getToken = (payload) => {
  const url = envBaseUrl + servicesList.cart + "/v1/restaurant/cart/get/token";
  return postRequest(url, payload);
};

export const repeatOrder = (payload) => {
  const url = envBaseUrl + servicesList.cart + "/v1/restaurant/cart/reorder";
  return postRequest(url, payload);
};

export const updateRestaurantCartProductStatus = (payload) => {
  const url = envBaseUrl + servicesList.cart + "/v1/restaurant/cart/update/product/status";
  return postRequest(url, payload);
};

export const restaurantCartClose = (payload) => {
  const url = envBaseUrl + servicesList.cart + "/v1/restaurant/cart/close";
  return postRequest(url, payload);
};

export const cartAggView = (payload) => {
  const url = envBaseUrl + servicesList.cart + "/v1/restaurant/cart/aggs/view";
  return postRequest(url, payload);
};

export const recallOrder = (payload) => {
  const url = envBaseUrl + servicesList.cart + "/v1/restaurant/cart/order/re-call";
  return postRequest(url, payload);
};

export const updateTableInformation = (slotId, payload) => {
  const url =
    envBaseUrl + servicesList.retailService + `/api/reservations/update/table/booking/${slotId}`;
  return putRequest(url, payload);
};

// expenses apis

export const createSessionExpense = (payload) => {
  const url = envBaseUrl + "finance/v1/expense/create";
  return postRequest(url, payload);
};

export const getAllSessionExpenses = (orgId, locationId, page, size, posSessionId) => {
  const url =
    envBaseUrl +
    `finance/v1/voucher-entry/get-all-expense/pos-session?page=${page}&size=${size}&organizationId=${orgId}&locationId=${locationId}&posSessionId=${posSessionId}`;
  return gettRequest(url, METHOD.GET);
};

export const updateSessionExpense = (payload) => {
  const url = envBaseUrl + "finance/v1/expense/update";
  return postRequest(url, payload);
};

export const getAllExpensesLedgers = (page, size, orgId) => {
  const url =
    envBaseUrl +
    `finance/v1/ledger/get-all-by-expense-group?page=${page}&size=${size}&organizationId=${orgId}`;
  return gettRequest(url, METHOD.GET);
};

export const getExpenseDetailsById = (id) => {
  const url = envBaseUrl + `finance/v1/voucher-entry/get-by-reference-id/${id}`;
  return gettRequest(url, METHOD.GET);
};

//stock adjustments

export const getAllStockAdjustments = (payload) => {
  const url =
    envBaseUrl + servicesList.inventoryService + "/v1/adjustment/get/adjustment-logs/pos-listing";
  return postRequest(url, payload);
};

export const getStockAdjustmentsSummary = (payload) => {
  const url =
    envBaseUrl + servicesList.inventoryService + "/v1/adjustment/get/adjustment-summary/pos";
  return postRequest(url, payload);
};

export const getStockAdjustmentsDetails = (payload) => {
  const url =
    envBaseUrl + servicesList.inventoryService + "/api/v1/get/stock_adjustment/details/display";
  return postRequest(url, payload);
};

export const getProductDetailsIMS = (payload) => {
  const url = envBaseUrl + servicesList.inventoryService + "/api/v1/inventory/data/get";
  return postRequest(url, payload);
};

export const getBatchDetailsById = (gtin, locId) => {
  const url =
    envBaseUrl +
    servicesList.inventoryService +
    `/api/inventory//v1/batch/list/get?GTIN=${gtin}&location_id=${locId}`;
  return gettRequest(url, METHOD.GET);
};

export const createAdjustmentLogs = (payload) => {
  const url = envBaseUrl + servicesList.inventoryService + "/v1/adjustment/create";
  return postRequest(url, payload);
};

export const getStockCountProducts = (page, size, posDayId, searchTerm) => {
  let url =
    envBaseUrl +
    servicesList.inventoryService +
    `/v1/pos-stock-count/batch-details?page=${page}&size=${size}&posDayId=${posDayId}`;
  if (searchTerm) {
    url += `&searchBox=${encodeURIComponent(searchTerm)}`;
  }

  return gettRequest(url, METHOD.GET);
};

export const updateStockCount = (payload) => {
  const url = envBaseUrl + servicesList.inventoryService + "/v1/pos-stock-count/update-batch";
  return postRequest(url, payload);
};

export const getInventoryPosConfig = (orgId, locId) => {
  const url =
    envBaseUrl +
    servicesList.inventoryService +
    `/v1/configuration/get?locationId=${locId}&organizationId=${orgId}`;
  return gettRequest(url, METHOD.GET);
};

export const closeDay = (payload) => {
  const url = envBaseUrl + servicesList.sessionService + "/day/v2/stop";
  return postRequest(url, payload);
};

export const complimentaryCart = (payload) => {
  const url = envBaseUrl + servicesList.cart + "/v1/restaurant/cart/mark/complementary";
  return postRequest(url, payload);
};

export const revertcomplimentaryCart = (payload) => {
  const url = envBaseUrl + servicesList.cart + "/v1/restaurant/cart/revert/complementary";
  return postRequest(url, payload);
};

export const getEndDayReportData = (locId, orgId) => {
  const url =
    envBaseUrl +
    servicesList.orderService +
    `/reports/restaurant/day/end/sales-report/${locId}/${orgId}`;
  return gettRequest(url, METHOD.GET);
};

export const getAllActiveSessions = (locId) => {
  const url =
    envBaseUrl + servicesList.sessionService + `/session/v3/get/active?locationId=${locId}`;
  return gettRequest(url, METHOD.GET);
};

export const getAllTablesByAreaId = (payload) => {
  const url = envBaseUrl + servicesList.retailService + "/api/tables/fetch-by-parent";
  return postRequest(url, payload);
};

export const transferTable = (payload) => {
  const url = envBaseUrl + servicesList.cart + "/v1/restaurant/cart/switch/user";
  return postRequest(url, payload);
};

export const pauseOnlineOrderRestaurant = (payload) => {
  const url = envBaseUrl + servicesList.thirdPartyLayer + "/store/v1/store-toggle";
  return postRequest(url, payload);
};

export const pauseOnlineOrderRestaurantV2 = (payload) => {
  const url = envBaseUrl + servicesList.thirdPartyLayer + "/store/v2/store-toggle";
  return postRequest(url, payload);
};

export const connectPrinterAgent = (payload) => {
  const url = `http://localhost:8442/printer/local/store`;
  return postRequest(url, payload);
};

export const getAllPrinterConfigs = () => {
  const url = `http://localhost:8442/printer/config`;
  return gettRequest(url, METHOD.GET);
};

export const getPrinterAgentStatus = () => {
  const url = `http://localhost:8442/printer/status`;
  return postRequest(url);
};

export const stopPrinterAgent = (status) => {
  const url = `http://localhost:8442/printer/application/status?status=${status}`;
  return postRequest(url);
};

export const testPrintAgent = (payload) => {
  const url = `http://localhost:8442/print/direct`;
  return postRequest(url, payload);
};

export const testPrinterWithContent = (payload) => {
  const url = `http://localhost:8442/printer/test`;
  return postRequest(url, payload);
};

export const stopForcePrinterAgent = () => {
  const url = `http://localhost:8442/printer/force/stop`;
  return postRequest(url);
};

export const refreshPrinterConfig = () => {
  const url = `http://localhost:8442/printer/config/refresh`;
  return postRequest(url);
};

export const addCommentsForSingleProduct = (payload) => {
  const url = envBaseUrl + servicesList.cart + "/v1/restaurant/cart/update/product/note";
  return postRequest(url, payload);
};

export const getAllTablePins = (payload) => {
  const url = envBaseUrl + servicesList.retailService + `/api/table/get-all-generated-pins`;
  return postRequest(url, payload);
};

export const getTableTasksForWaiters = (payload) => {
  const url = envBaseUrl + servicesList.retailService + "/api/v1/table-tasks/filter";
  return postRequest(url, payload);
};

export const completeTaskByWaiter = (payload) => {
  const url = envBaseUrl + servicesList.retailService + `/api/v1/table-tasks/task/complete`;
  return postRequest(url, payload);
};

export const deleteAllTasksForTable = (tableId) => {
  const url =
    envBaseUrl + servicesList.retailService + `/api/v1/table-tasks/table/${tableId}/clear`;
  return deleteRequest(url);
};

export const checkWhetherAgentRunsLoc = (locId, orgId) => {
  const url =
    envBaseUrl +
    servicesList.retailService +
    `/printer-agent/get/status?locationId=${locId}&orgId=${orgId}`;
  return gettRequest(url, METHOD.GET);
};

export const filterJobs = (payload) => {
  const url = envBaseUrl + servicesList.sessionService + "/job/filter/job";
  return postRequest(url, payload);
};

export const KdsAggsviews = (payload) => {
  const url = envBaseUrl + servicesList.sessionService +
    "/job/aggregated/tasks/filter?aggregationType=" + encodeURIComponent(payload.aggregationType) +
    "&page=" + encodeURIComponent(payload.page) + "&pageSize=" + encodeURIComponent(payload.pageSize);
  return postRequest(url, payload);
};

export const updateJobs = (payload) => {
  const url = envBaseUrl + servicesList.sessionService + "/job/update/job/status";
  return postRequest(url, payload);
};

export const KdsAggsUpdate = (payload) => {
  const url = envBaseUrl + servicesList.sessionService + "/job/aggregated/tasks/update";
  return postRequest(url, payload);
};

export const KdsTableViewUpdate = (payload) => {
  const url = envBaseUrl + servicesList.sessionService + "/job/aggregated/table/update/status";
  return postRequest(url, payload);
};

export const updateTaskStatus = (payload) => {
  const url = envBaseUrl + servicesList.sessionService + "/job/update/task/status";
  return postRequest(url, payload);
};

export const editJobItemQty = (payload) => {
  const url = envBaseUrl + servicesList.sessionService + "/job/task/qty/edit";
  return postRequest(url, payload);
};

export const revertPrevAction = (payload) => {
  const url = envBaseUrl + servicesList.sessionService + "/job/task/qty/revert";
  return postRequest(url, payload);
};

export const getAllPrepStations = (payload) => {
  const url = envBaseUrl + servicesList.catalogService + "/prep-station/filter";
  return postRequest(url, payload);
};

export const getRecalledItemsList = (payload) => {
  const url = envBaseUrl + servicesList.sessionService + "/job/tasks/filter";
  return postRequest(url, payload);
};

export const changeStockStatus = (payload) => {
  const url = envBaseUrl + servicesList.catalogService + "/product/stock/update";
  return postRequest(url, payload);
};

export const getAggStockStatusMenu = (payload) => {
  const url = envBaseUrl + servicesList.catalogService + "/v1/product/common/aggs/stock";
  return postRequest(url, payload);
};

export const addComplimentaryinKDS = (payload) => {
  const url = envBaseUrl + servicesList.sessionService + "/job/add/task";
  return postRequest(url, payload);
};

export const reprintKot = (payload) => {
  const url = envBaseUrl + servicesList.sessionService + "/job/reopen/print/job";
  return postRequest(url, payload);
};

export const checkLogisticService = (payload) => {
  const url =
    envBaseUrl + servicesList.thirdPartyLayer + "/logistics/on-demand/adhoc/serviceability";
  return postRequest(url, payload);
};

export const manualLogisticBooking = (payload) => {
  const url = envBaseUrl + servicesList.thirdPartyLayer + "/logistics/on-demand/orders";
  return postRequest(url, payload);
};
export const getTableStatusByCart = (payload) => {
  const url = envBaseUrl + servicesList.cart + "/v1/restaurant/cart/retrieve/cart/quick";
  return postRequest(url, payload);
};

export const cancelLogistics = (payload) => {
  const url = envBaseUrl + servicesList.logisticsService + `/order/v1/pos/cancel`;
  return postRequest(url, payload);
};
// logistics
export const getLogiscticsTodayOrders = (payload) => {
  const url = envBaseUrl + servicesList.logisticsService + "/dashboard/v1/get/todayOrders";
  return postRequest(url, payload);
};

export const getLogisticsShipmentDetails = (shipmentId) => {
  const url =
    envBaseUrl +
    servicesList.logisticsService +
    `/dashboard/v1/get/shipmentDetails?shipmentId=${shipmentId}`;
  return gettRequest(url);
};

export const getHistoricalLogisticsOrder = (payload) => {
  const url = envBaseUrl + servicesList.logisticsService + "/dashboard/v1/get/historicalOrders";
  return postRequest(url, payload);
};

export const getLogisticsSummary = (payload) => {
  const url = envBaseUrl + servicesList.logisticsService + "/dashboard/v1/get/todaySummary";
  return postRequest(url, payload);
};

export const getRazorpayCredentials = () => {
  const url =
    envBaseUrl + servicesList.palletPayments + "/credential/v1/paymentGateway/ORGANIZATION/PALLET";
  return gettRequest(url);
};

export const refreshLogisticShipmentDetails = (shipmentId) => {
  const url =
    envBaseUrl +
    servicesList.logisticsService +
    `/dashboard/v1/refresh/shipment?shipmentId=${shipmentId}`;
  return postRequest(url, shipmentId);
};

// logistics partner booking flow
export const getDeliveryPartners = (payload) => {
  const url =
    envBaseUrl + servicesList.thirdPartyLayer + `/logistics/on-demand/adhoc/serviceability`;
  return postRequest(url, payload);
};

export const bookDeliveryPartners = (payload) => {
  const url = envBaseUrl + servicesList.thirdPartyLayer + `/logistics/on-demand/orders`;
  return postRequest(url, payload);
};

export const cancelLogisticsOrder = (payload) => {
  const url = envBaseUrl + servicesList.logisticsService + `/order/v1/cancel`;
  return postRequest(url, payload);
};

export const filterHotsellingProducts = (payload, config) => {
  const url = envBaseUrl + servicesList.catalogService + `/api/most-sold-products/list`;
  return postRequest(url, payload, config);
};

export const retryRiderEndpoint = (orderId) => {
  const url =
    envBaseUrl + servicesList.thirdPartyLayer + `/internal/logistics/retry-logistics/${orderId}`;
  return postRequest(url);
};

export const getNewOrderNotification = (locId, orgId) => {
  const url =
    envBaseUrl +
    servicesList.retailService +
    `/api/v1/notifications/aggregator/active?orgId=${orgId}&locationId=${locId}`;
  return gettRequest(url, METHOD.GET);
};

export const getAllHelpSupportTickets = (payload, locId, orgId) => {
  const url = envBaseUrl + servicesList.retail + `/task/get/tickets?srcId=${locId}&orgId=${orgId}`;
  return postRequest(url, payload);
};

export const getHelpSupportTicketSummary = (payload) => {
  const url = envBaseUrl + servicesList.retail + `/task/get/ticket/summary`;
  return postRequest(url, payload);
};

export const uploadByteImage = (payload) => {
  const url = envBaseUrl + servicesList.retail + `/attachment/upload`;
  return postRequest(url, payload);
};

export const getProjects = (payload) => {
  const url = envBaseUrl + servicesList.retail + `/project/get/projects`;
  return postRequest(url, payload);
};

export const getProjectFeatures = (projectId, payload) => {
  const url =
    envBaseUrl + servicesList.retail + `/feature/${projectId}/features?projectId=${projectId}`;
  return postRequest(url, payload);
};

export const getHelpAndSupportTicketDetail = (ticketId) => {
  const url = envBaseUrl + servicesList.retail + `/task/get/ticket/details?ticketId=${ticketId}`;
  return gettRequest(url, METHOD.GET);
};

export const createTask = (payload) => {
  const url = envBaseUrl + servicesList.retail + `/task/create`;
  return postRequest(url, payload);
};

export const sendCommentTicketMessage = (payload, TASK_ID) => {
  const url = envBaseUrl + servicesList.retail + `/comment/task/${TASK_ID}`;
  return postRequest(url, payload);
};

export const getCommentTicketMessage = (payload, TASK_ID) => {
  const url = envBaseUrl + servicesList.retail + `/comment/get/${TASK_ID}`;
  return postRequest(url, payload);
};

export const updateTask = (payload) => {
  const url = envBaseUrl + servicesList.retail + `/task/update/task`;
  return patchRequest(url, payload);
};

export const getAllTicketTimeline = (TICKET_ID) => {
  const url = envBaseUrl + servicesList.retail + `/task/timeline/all/${TICKET_ID}`;
  return postRequest(url);
};

export const filterTickets = (payload, LOC_ID, ORG_ID) => {
  const url = envBaseUrl + servicesList.retail + `/task/filter/ticket/${LOC_ID}/${ORG_ID}`;
  return postRequest(url, payload);
};

export const createStoreConfig = (payload) => {
  const url = envBaseUrl + servicesList.retail + `/store-config/v1/create`;
  return postRequest(url, payload);
};

export const updateStoreConfig = (payload) => {
  const url = envBaseUrl + servicesList.retail + `/store-config/v1/update`;
  return postRequest(url, payload);
};

export const getBlogFilter = (payload) => {
  const url = envBaseUrl + servicesList.catalogService + `/blog/filter`;
  return postRequest(url, payload);
};

export const getBlogCategoryFilter = (payload) => {
  const url = envBaseUrl + servicesList.catalogService + `/blog/category/filter`;
  return postRequest(url, payload);
};

export const getBlogSubCategoryFilter = (payload) => {
  const url = envBaseUrl + servicesList.catalogService + `/blog/sub-category/filter`;
  return postRequest(url, payload);
};

export const getBlogProductFilter = (payload) => {
  const url = envBaseUrl + servicesList.catalogService + `/blog/product/filter`;
  return postRequest(url, payload);
};

export const getBlogFilterPreview = (id) => {
  const url = envBaseUrl + servicesList.catalogService + `/blog/get/${id}`;
  return gettRequest(url, METHOD.GET);
};

export const getWeatherConditions = (lat, long, days) => {
  const url =
    envBaseUrl + servicesList.retail + `/weather/current?lat=${lat}&lon=${long}&days=${days}`;
  return gettRequest(url, METHOD.GET);
};

export const getB2BCustomerEndpoint = (payload) => {
  const url = envBaseUrl + servicesList.retail + `/retail/v2/get/partner/retail`;
  return postRequest(url, payload);
};

/**
 * Create a new B2B customer (wholesaler / GST-registered business).
 * Used when the staff registers a new organisation from the GST Invoice tab.
 */
export const createB2BCustomer = (payload) => {
  const url = envBaseUrl + servicesList.retail + `/retail/v2/create`;
  return postRequest(url, payload);
};

export const getPosCustomersByLocation = (payload) => {
  const url = envBaseUrl + servicesList.retail + `/retail/v2/customer/location`;
  return postRequest(url, payload);
};

export const getAppCustomers = (payload) => {
  const url = envBaseUrl + servicesList.customerService + `/customer/v2/get`;
  return postRequest(url, payload);
};

export const fetchCustomerLoyaltyPointDetails = (payload) => {
  const url =
    envBaseUrl + servicesList.loyaltyService + `/api/loyaltyPoints/customer/loyalty/details`;
  return postRequest(url, payload);
};

export const fetchRetailCustomer = (retailId, orgId) => {
  const url =
    envBaseUrl + servicesList.retailService + `/retail/customer/v1/${retailId}?orgId=${orgId}`;
  return gettRequest(url, METHOD.GET);
};

export const fetchCoupounDetails = (payload) => {
  const url = envBaseUrl + servicesList.couponService + `/api/v1/get/coupon/details/mobile-number`;
  return postRequest(url, payload);
};

export const fetchB2BCustomerByPhoneNumber = (phoneNumber) => {
  const url =
    envBaseUrl + servicesList.customerService + `/customer/v1/get/phone?phoneNumber=${phoneNumber}`;
  return gettRequest(url, METHOD.GET);
};

export const getWalletBalance = (id) => {
  const url = envBaseUrl + servicesList.customerService + `/wallet/v1/balances/${id}`;
  return gettRequest(url, METHOD.GET);
};

export const checkCustomerExist = (payload) => {
  const url = envBaseUrl + servicesList.retailService + `/retail/customer/v1/exists`;
  return postRequest(url, payload);
};

export const getAllOrders = (payload) => {
  const url = envBaseUrl + servicesList.orderService + `/orders/v2/orders`;
  return postRequest(url, payload);
};

export const getCustomerLoyaltyDetail = (payload) => {
  const url = envBaseUrl + servicesList.orderService + `/customer/customer-orders/loyalty`;
  return postRequest(url, payload);
};

export const applyOrderLevelDiscount = (payload) => {
  const url = envBaseUrl + servicesList.cart + `/common/cart/apply/discount`;
  return postRequest(url, payload);
};

export const multiLocationSessionDetails = (payload) => {
  const url =
    envBaseUrl + servicesList.orderService + `/main/dashboard/sales/data/multi-location-sessions`;
  return postRequest(url, payload);
};

export const productStatusToggle = (payload) => {
  const url = envBaseUrl + servicesList.catalogService + `/product/v2/activate/deactivate`;
  return postRequest(url, payload);
};

export const returnSearchApi = (returnId) => {
  const url =
    envBaseUrl + servicesList.orderService + `/returns/return/search?return-id=${returnId}`;
  return gettRequest(url, METHOD.GET);
};

export const getMachineDetails = (payload) => {
  const url = envBaseUrl + servicesList.palletBusiness + `/api/license/machine/details`;
  return postRequest(url, payload);
};

export const getInvoiceDocument = (orderId) => {
  const url = envBaseUrl + servicesList.orderService + `/reports/v1/download/taxInvoice/${orderId}`;
  return pdfgetRequest(url, METHOD.GET);
};

export const getTopPerformer = (payload) => {
  const url =
    envBaseUrl + servicesList.orderService + `/main/product/dashboard/sales/data/item-sales`;
  return postRequest(url, payload);
};

export const getSessionClosingReportsDownload = (sessionId) => {
  const url = envBaseUrl + servicesList.orderService + `/reports/report/${sessionId}`;
  return gettRequest(url, METHOD.GET);
};

export const getDayClosingReportsDownload = (payload) => {
  const url = envBaseUrl + servicesList.orderService + `/reports/download/dayClosingReport`;
  return postRequest(url, payload);
};

export const removeLoyaltyNew = (payload) => {
  const url = envBaseUrl + servicesList.cart + `/common/cart/loyalty/remove`;
  return postRequest(url, payload);
};

export const flushCartNew = (payload) => {
  const url = envBaseUrl + servicesList.cart + `/common/cart/product/remove/all`;
  return postRequest(url, payload);
};

export const getUserRolesByFilter = (payload) => {
  const url = envBaseUrl + servicesList.userService + `/users/filter`;
  return postRequest(url, payload);
};

export const getUserRolesById = (userId, orgId, locationId) => {
  const url = envBaseUrl + servicesList.userService + `/users/lookup/by-uidx?uidx=${userId}`;
  const extraHeaders = { orgId };
  if (locationId) extraHeaders.locationId = locationId;
  return gettRequest(url, METHOD.GET, extraHeaders);
};

export const odsSearch = (payload) => {
  const url = envBaseUrl + servicesList.orderService + `/v7/orders/search`;
  return postRequest(url, payload);
};

export const getOrdersByChannelApi = (payload) => {
  const url = envBaseUrl + servicesList.sessionService + `/job/home/cart/count`;
  return postRequest(url, payload);
};

export const getOrdersByChannelGroceryApi = (payload) => {
  const url = envBaseUrl + servicesList.orderService + `/main/dashboard/sales/data/day-report`;
  return postRequest(url, payload);
};

export const getCustomerWalletDetails = (customerId, orgId) => {
  const url =
    envBaseUrl +
    servicesList.customerService +
    `/pos/v1/loyalty-wallet?customerId=${customerId}&orgId=${orgId}`;
  return gettRequest(url, METHOD.GET);
};

export const loginTimeline = (payload) => {
  const url = envBaseUrl + servicesList.userService + `/users/login/timeline`;
  return postRequest(url, payload);
};

/* ── Account & Subscription APIs (platform: RMS) ─────────── */
const rmsHeaders = { platform: "RMS" };

export const fetchAccountByOrg = (orgId) => {
  const url = envBaseUrl + servicesList.businessService + "/api/mapping/details/org/id";
  return postRequest(url, { orgId }, { headers: rmsHeaders });
};

export const fetchActiveSubscription = (payload) => {
  const url = envBaseUrl + servicesList.businessService + "/api/account-subscription";
  return postRequest(url, payload, { headers: rmsHeaders });
};

export const fetchActiveAddons = (payload) => {
  const url = envBaseUrl + servicesList.businessService + "/api/account/addon/fetch/active";
  return postRequest(url, payload, { headers: rmsHeaders });
};

export const fetchAddonDetails = (payload) => {
  const url = envBaseUrl + servicesList.businessService + "/api/addons/details";
  return postRequest(url, payload, { headers: rmsHeaders });
};

export const fetchUpcomingBilling = (payload) => {
  const url =
    envBaseUrl + servicesList.businessService + "/api/account-subscription/upcomingBilling";
  return postRequest(url, payload, { headers: rmsHeaders });
};

export const fetchAddonCategorySummary = (payload) => {
  const url = envBaseUrl + servicesList.businessService + "/api/addons/category-summary";
  return postRequest(url, payload, { headers: rmsHeaders });
};

export const fetchAddonsByCategory = (payload) => {
  const url = envBaseUrl + servicesList.businessService + "/api/addons/by-category";
  return postRequest(url, payload, { headers: rmsHeaders });
};

/* ── Face-ID / Attendance ─────────────────────────────── */

/** Enrol an employee's face (initial enrolment) */
export const enrollFace = (payload) => {
  const url = envBaseUrl + servicesList.retailService + "/attendance/v1/face/enroll";
  return postRequest(url, payload);
};

/** Add an additional face image to an existing enrolment */
export const enrollFaceAdditional = (payload) => {
  const url = envBaseUrl + servicesList.retailService + "/attendance/v1/face/enroll/additional";
  return postRequest(url, payload);
};

/** Check whether a token / enrolment exists for an employee */
export const checkEnrollmentStatus = (payload) => {
  const url = envBaseUrl + servicesList.retailService + "/attendance/v1/face/tokens/check";
  return postRequest(url, payload);
};

/** Recognise a face and record an attendance swipe */
export const recognizeFace = (payload) => {
  const url = envBaseUrl + servicesList.retailService + "/api/attendance/v1/recognize";
  return postRequest(url, payload, { headers: { platform: "TRUEFACE" } });
};

/** Fetch a single attendance record by its ID */
export const getAttendanceById = (attendanceId) => {
  const url = envBaseUrl + servicesList.retailService + `/api/attendance/v1/${attendanceId}`;
  return gettRequest(url, METHOD.GET);
};

/** List attendance records (paginated, filterable) */
export const listAttendance = (payload) => {
  const url = envBaseUrl + servicesList.retailService + "/api/attendance/v1/list";
  return postRequest(url, payload);
};

/* ═══════════════════════════════════════════════════════════
   Employee Enrollment APIs
   ═══════════════════════════════════════════════════════════ */

/** List unenrolled employees (paginated, filterable) */
export const listUnenrolledEmployees = (payload) => {
  const url = envBaseUrl + servicesList.retailService + "/api/face/v1/tokens/unenrolled";
  return postRequest(url, payload);
};

/**
 * Check if an employee already has a face token enrolled.
 * GET /retail-service/api/face/v1/tokens/check/{employeeId}/{orgId}?locationId=...
 */
export const checkEnrollmentStatusById = (employeeId, orgId, locationId) => {
  const qs = locationId ? `?locationId=${encodeURIComponent(locationId)}` : "";
  const url =
    envBaseUrl +
    servicesList.retailService +
    `/api/face/v1/tokens/check/${encodeURIComponent(employeeId)}/${encodeURIComponent(orgId)}${qs}`;
  return gettRequest(url, METHOD.GET);
};

/** Initial face enrollment */
export const enrollFaceEnroll = (payload) => {
  const url = envBaseUrl + servicesList.retailService + "/api/face/v1/enroll";
  return postRequest(url, payload);
};

/** Enroll an additional face image for an already-enrolled employee */
export const enrollFaceAdditionalEnroll = (payload) => {
  const url = envBaseUrl + servicesList.retailService + "/api/face/v1/enroll/additional";
  return postRequest(url, payload);
};

/** Fetch departments for the enrollment filter modal */
export const listDepartmentsForFilter = (orgId) => {
  const url = envBaseUrl + servicesList.retail + "/departments/search/department";
  return postRequest(url, { organizationId: orgId, page: 0, size: 200 });
};

/** Fetch designations for the enrollment filter modal */
export const listDesignationsForFilter = (orgId) => {
  const url = envBaseUrl + servicesList.retail + "/designations/search/designations";
  return postRequest(url, { organizationId: orgId, page: 0, size: 200 });
};

/** Fetch an employee record by uidx */
export const getEmployeeByUidx = (uidx) => {
  const url = envBaseUrl + servicesList.retail + `/employees/get/employee/by-uidx/${uidx}`;
  return gettRequest(url, METHOD.GET);
};

export const customerSearchV2Api = (payload) => {
  const url = envBaseUrl + servicesList.customerService + `/customer/v3/get-customer-list`;
  return postRequest(url, payload);
}

export const getCustomerDetailsV2 = (customerId) => {
  const url = envBaseUrl + servicesList.customerService + `/customer/v1/get?customerId=` + customerId;
  return gettRequest(url, METHOD.GET);
}

export const createB2CcustomerApi = (payload) => {
  const url = envBaseUrl + servicesList.customerService + `/customer/v2/create`;
  return postRequest(url, payload);
}

export const getKOTStatus = (payload) => {
  const url = envBaseUrl + servicesList.sessionService + `/job/home/kot/count`;
  return postRequest(url, payload);
}

export const customerAnalyticsOverviewApi = (customerId) => {
  const url = envBaseUrl + servicesList.customerService + `/api/v1/customer-analytics/customerOverview/byId?customerId=` + customerId;
  return gettRequest(url, METHOD.GET);
}
